import { BankIcons, getBankIcon } from '../../../modules/theme/bank-icons.function';

type BankIconProps = {
  bank: BankIcons | undefined;
};

export const BankIcon = ({ bank }: BankIconProps) => {
  return <img src={getBankIcon(bank)} alt='Bank Icon' />;
};
